{
    "$schema": "https://schema.management.azure.com/providers/Microsoft.Logic/schemas/2016-06-01/workflowdefinition.json#",
    "contentVersion": "1.0.0.0",
    "parameters": {
      "$connections": {
        "defaultValue": {},
        "type": "Object"
      },
      "$authentication": {
        "defaultValue": {},
        "type": "SecureObject"
      }
    },
    "triggers": {
      "When_a_file_is_created_or_modified_(properties_only)": {
        "recurrence": {
          "interval": 1,
          "frequency": "Minute"
        },
        "splitOn": "@triggerBody()?['value']",
        "metadata": {
          "flowSystemMetadata": {
            "swaggerOperationId": "GetOnUpdatedFileItems"
          }
        },
        "type": "ApiConnection",
        "inputs": {
          "host": {
            "connection": {
              "name": "@parameters('$connections')['shared_sharepointonline']['connectionId']"
            }
          },
          "method": "get",
          "path": "/datasets/@{encodeURIComponent(encodeURIComponent('https://johnliu365.sharepoint.com/'))}/tables/@{encodeURIComponent(encodeURIComponent('250272a5-f5d5-465b-846f-3dbde6f35ce7'))}/onupdatedfileitems",
          "authentication": "@parameters('$authentication')"
        }
      }
    },
    "actions": {
      "HTTP": {
        "runAfter": {},
        "type": "Http",
        "inputs": {
          "method": "POST",
          "uri": "https://prod-17.australiasoutheast.logic.azure.com:443/workflows/58c3e6b52a31497c8cb3fe2abb5600db/triggers/manual/paths/invoke?api-version=2016-06-01&amp;sp=%2Ftriggers%2Fmanual%2Frun&amp;sv=1.0&amp;sig=L-cOKq24RSuIVBqvtPZ4hULAqh9BBKYJLQxKuE_aL4U",
          "headers": {
            "accept": "application/json;odata=verbose",
            "content-type": "application/json;odata=verbose"
          },
          "body": {
            "list": "",
            "web": "",
            "item": "",
            "title": "",
            "initiator": ""
          }
        }
      }
    }
  }